export default __webpack_public_path__ + "components/weather-icon/static/daymodrain-a948ee4275f954778b9fff62de2ad322.webp";